import React,{useState,useEffect} from 'react';
import AlimLoader from '../ui-elements/AlimLoader';
import AlimNotes from '../user/AlimNotes';
import PostNoteModal from '../user/PostNoteModal';
import { useStore } from '@nanostores/react';
import { alimSessionValid } from '../../stores/sessionStore';

const NotesSectionContainer=({noteCat,noteRefer,isNotesModal})=>{
    const [alimToken, setAlimToken]=useState(null);
    const [userData,setUserData]=useState(null);
    const [isValidUser, setIsValidUser]=useState("0");
    const [noteRef,setNoteRef]=useState(noteRefer);
    const [surahId,setSurahId]=useState(noteRefer.substr(0,noteRefer.indexOf("A")));
    const [showAddNoteModal,setShowAddNoteModal]=useState(false);
    const [notesMsg,setNotesMsg]=useState("");
    const isAlimSessionValid=useStore(alimSessionValid);

    const initiateAuth=()=>{
        const tempAlimToken=localStorage.getItem('alim-login-token');
        const userTempData=JSON.parse(localStorage.getItem('alim-user-data'));
        if(tempAlimToken!==null&&userTempData!==null)
        {
            setAlimToken(tempAlimToken);
            setUserData(userTempData);
        }
        else
        {
            setIsValidUser("2");
        }
    }

    useEffect(()=>{
        const tafsirEventHandler=()=>{
            const searchParams = new URLSearchParams(document.location.search);
            setNoteRef(`${surahId}A${searchParams.get('ayah')}`);
        }
        document.addEventListener("ayah-change",tafsirEventHandler);

        return()=>{
            document.removeEventListener("ayah-change", tafsirEventHandler);
        }
    });

    useEffect(()=>{
        const loginHandler=()=>{
            initiateAuth();
            if (window.parent && window.parent !== window) {
                window.parent.postMessage("alim-login");
            }
        }
        document.addEventListener("alim-login",loginHandler);

        return()=>{
            document.removeEventListener("alim-login", loginHandler);
        }
    });

    useEffect(()=>{
    },[isValidUser,noteRef]);

    useEffect(()=>{
        if(alimToken!==null&&userData!==null&&alimSessionValid)
        {
            setIsValidUser("1");
        }
    },[alimToken,userData,isAlimSessionValid]);

    useEffect(()=>{
        initiateAuth();
    },[]);

    return(
        <>
            {
                isValidUser==="0"&&
                <AlimLoader loaderMsg={"Please wait..."}/>
            }

            {
                isValidUser==="1"&&
                <div className='alim-text-color-style grid grid-cols-2'>
                    <div className='col-span-2 md:col-span-1'>
                        {/* <h2>Your notes</h2> */}
                        <p>{notesMsg}</p>
                    </div>
                    <div className='col-span-2 md:col-span-1 flex md:justify-end pt-0 md:pt-5 pb-3'>
                        <button className='bg-deep-red px-5 py-2 rounded-md text-white' onClick={()=>{setShowAddNoteModal(!showAddNoteModal)}}>
                            Add note
                        </button>
                    </div>
                    <div className='col-span-2'>
                        {notesMsg===""&&<AlimNotes key={noteRef} webToken={alimToken} alimUserID={userData.user_email} noteCat={noteCat} noteRefer={noteRef} noteSection={"1"} isNotesModal={isNotesModal}/>}
                        {
                            showAddNoteModal&&
                            <PostNoteModal webToken={alimToken} userMail={userData.user_email} noteCat={noteCat} noteRefer={noteRef} modalFunc={setShowAddNoteModal} isNotesModal={isNotesModal}/>
                        }
                    </div>
                </div>
                
            }

            {
                isValidUser==="2"&&
                <div className={`flex flex-col justify-center h-full w-full gap-6`}>
                    <span className={`alim-text-color-style text-2xl font-bold ${isNotesModal==="1"?`mt-8`:``}`}>Please login to create and view notes</span>
                    <button  className='bg-deep-red px-5 py-2 rounded-md text-white w-fit' onClick={()=>{
                        window.open('/login?ref=1');
                    }}>
                        Login
                    </button>
                </div>
            }
        </>
    );
}

export default NotesSectionContainer;